import { halloween } from './halloween';
import type { RandomGameBranding } from './types';

export type { CardRevealProps, RandomGameBranding } from './types';

// Keyed by the lower-cased seasonalBranding flag. Add a folder + one line here for a new branding.
export const RANDOM_GAME_BRANDINGS: Record<string, RandomGameBranding> = {
  halloween,
};
